import { Space } from 'antd';
import PropTypes from 'prop-types';
import { CheckboxSummary, TitleSummary } from '../../style';

export const CheckboxGroupComponent = ({ field }) => {
  return (
    <>
      <TitleSummary level={5}>{field.label}</TitleSummary>
      <Space key={field.idInput} direction="vertical" style={{ marginBottom: '10px' }}>
        {field?.value?.map((values) => (
          <CheckboxSummary key={values.idInput} defaultChecked={values?.value} disabled>
            {' '}
            <p>{values.label}</p>
          </CheckboxSummary>
        ))}
      </Space>
    </>
  );
};

CheckboxGroupComponent.propTypes = {
  field: PropTypes.object.isRequired,
};
